<dx-data-grid
  class="flex-1"
  [allowColumnReordering]="false"
  [remoteOperations]="{ paging: true }"
  [glamResource]="resource">

  <dxo-selection mode="none"></dxo-selection>

  <dxo-scrolling
    mode="virtual"
    rowRenderingMode="virtual"
    columnRenderingMode="standard">
  </dxo-scrolling>

  <dxi-column
    dataField="productCode"
    [caption]="'entity.batch.productId' | translate | ucfirst"
    cellTemplate="productTemplate">
  </dxi-column>

  <div *dxTemplate="let cell of 'productTemplate'">
    <div class="d-flex align-items-center">
          <span class="tree-depth dx-theme-accent-as-text-color d-flex" style="font-size: 8px; margin-right: 6px; letter-spacing: 2px">
            <span
              *ngFor="let i of [].constructor(cell.data.depth ?? 0)"
              class="me-2"
            >
              ◉
            </span>
          </span>
      <strong>{{ cell.data.productCode }}</strong>
      <span class="hover:underline cursor-pointer ms-2"
            (click)="openProduct(cell.data)">
            {{ cell.data.productName }}
          </span>
    </div>
  </div>

  <dxi-column
    dataField="batch"
    cellTemplate="batchTemplate"
    [caption]="'entity.batch.batch' | translate | ucfirst">
    <div *dxTemplate="let cell of 'batchTemplate'">
           <span class="hover:underline cursor-pointer"
                 (click)="openBatch(cell.data)">
            {{ cell.data.batch }}
          </span>
    </div>
  </dxi-column>

  <dxi-column
    dataField="documentNumber"
    cellTemplate="documentTemplate"
    [caption]="'common.tabTitle.purchaseOrders' | translate | ucfirst">
    <div *dxTemplate="let cell of 'documentTemplate'">
      <span *ngIf="cell.data.documentNumber"
            class="hover:underline cursor-pointer"
            (click)="openDocument(cell.data)">
            {{ cell.data.documentNumber }}
          </span>
      <span *ngIf="!cell.data.documentNumber" class="text-muted">-</span>
    </div>
  </dxi-column>

  <dxi-column
    dataField="organizationLegalName"
    cellTemplate="organizationTemplate"
    [caption]="'entity.documentPendingBatch.organizationId' | translate | ucfirst">
    <div *dxTemplate="let cell of 'organizationTemplate'">
      <span *ngIf="cell.data.organizationLegalName"
            class="hover:underline cursor-pointer"
            (click)="openOrganization(cell.data)">
            {{ cell.data.organizationLegalName }}
          </span>
      <span *ngIf="!cell.data.organizationLegalName" class="text-muted">-</span>
    </div>
  </dxi-column>
</dx-data-grid>
